/* 全屏 webview
 * @Author: wjl 
 * @Date: 2022-02-23 15:29:45 
 * @Last Modified by: wjl
 * @Last Modified time: 2022-02-28 10:39:42
 */
// 
<template>
  <div :class="$style.view">
    <iframe :src="link" frameborder="0" :class="$style.iframe"></iframe>
    <p :class="$style.close">
      <img :src="`${$cdnLink}/suspend/qingbao/back.png`" alt="" @click="$emit('close')">
      <span @click="$emit('close')">返回游戏</span>
    </p>
  </div>
</template>

<script>
export default {
  name: '',
  props: ['link'],
  data () {
    return {
    };
  }
}
</script>

<style lang="scss" module>
.view {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  .iframe {
    width: 100%; 
    height: calc(100% - 40px);
    background: #FFFFFF;
  }
  .close {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 34px;
    background: linear-gradient(90deg, #ff7955, #ff3b36); 
    font-size: 16px;
    color: #FFFFFF;
    text-align: right;
    line-height: 34px;
    padding-right: 15px;
    display: flex;
    justify-content: space-between;
    align-content: center;
    img {
      margin-top: 6px;
      margin-left: 10px;
      // width: 40px;
      height: 25px;
    }
  }
}
</style>